import { Component, inject, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { Chip } from '../chip/chip';
import { IconComponent, SkeletonComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { ColorService } from '../../services/color.service';
import { Tooltip } from '../../directives/tooltip.directive';
import { TranslateModule } from '@ngx-translate/core';
import { IconType } from '@kinomap-dev/ng-ui-lib/core';
import { ModerationReason } from '../../types/moderation-reason.type';

export type Disponibility = {
  icon: IconType;
  label: string;
  disabled?: boolean;
};

@Component({
  selector: 'app-content-availability-block',
  imports: [Chip, IconComponent, Tooltip, IconComponent, TranslateModule, SkeletonComponent],
  templateUrl: './content-availability-block.html',
  styleUrl: './content-availability-block.scss',
})
export class ContentAvailabilityBlock {
  readonly colorService: ColorService = inject(ColorService);

  readonly disponibilities: InputSignal<Disponibility[]> = input<Disponibility[]>([
    {
      icon: 'language' as IconType,
      label: 'content.availability.website',
    },
    {
      icon: 'computer' as IconType,
      label: 'content.availability.app',
      disabled: true,
    },
  ]);
  readonly loading: InputSignal<boolean> = input<boolean>(false);
  readonly isExpandable: InputSignal<boolean> = input<boolean>(true);
  readonly moderationReasons: InputSignal<ModerationReason[] | undefined> = input<
    ModerationReason[] | undefined
  >(undefined);
  readonly moderationRefusedReasons: InputSignal<ModerationReason[] | undefined> = input<
    ModerationReason[] | undefined
  >(undefined);

  readonly isOpen: WritableSignal<boolean> = signal<boolean>(false);

  toggleIsOpen(): void {
    this.isOpen.update((isOpen: boolean) => !isOpen);
  }

  getReasonStatus(id: number): boolean {
    return !this.moderationRefusedReasons()
      ?.map((reason: ModerationReason) => reason.id)
      ?.includes(id);
  }
}
